<template>
  <div>
    <section id="over-rijnja" class="content-wrapper page">
      <section id="" class="row header">
        <ul class="breadcrumb">
          <li>
            <router-link class="link" to="/">Home</router-link>
          </li>

          <li>
            <inline-svg
              src="/images/icons/chevron-right-solid.svg"
            ></inline-svg>
            <router-link class="link" to="/hoe-doen-wij-dat"
              >Hoe doen wij dat
            </router-link>
          </li>
          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Duurzaamhed
          </li>
        </ul>
        <div class="col text">
          <h1>Duurzaamheid in het DNA</h1>
          <p>
            Als vierde generatie familiebedrijf voelen wij ons verbonden met de
            wereld om ons heen. Duurzaamheid zit in ons DNA en daarom willen wij
            actief bijdragen aan een gezonde en sociale samenleving. Dat doen we
            door zorgvuldige bedrijfsvoering met oog voor mens, milieu en
            maatschappij.
          </p>
          <h2>ISO certificering</h2>
          <p>
            Wij investeren voortdurend in vernieuwende technologie en duurzame
            printtechnieken voor veilige en innovatieve online-oplossingen. Wij
            werken volgens de hoogste en nieuwste kwaliteits- en
            milieumanagementnormen en zijn ISO 9001:2015 en ISO 14001:2015
            gecertificeerd. De ISO 27001:2022 certificering waarborgt daarnaast
            de beveiliging en vertrouwelijkheid van bestanden en gegevens
            gedurende het gehele printproces. Momenteel wordt toegewerkt naar
            het ISO 26000 certificaat voor maatschappelijk verantwoord
            ondernemen.
          </p>
          <h2>Andere maatregelen</h2>
          <p>
            Naast de ISO certificeringen worden andere duurzaamheidsmaatregelen
            toegepast. Zo gebruiken wij FSC gecertificeerd papier en
            klimaatneutraal geproduceerd verpakkingsmateriaal. In onze vijf
            vestigingen maken we de impact op het milieu zo klein mogelijk door
            optimaal gebruik te maken van duurzame energiebronnen en de
            CO2-uitstoot te beperken. Een van onze locaties is inmiddels
            volledig zelfvoorzienend. In 2022-2023 is het gehele machinepark
            vervangen door energiezuinige state-of-the-art apparatuur.
          </p>
        </div>

        <div class="col image">
          <img
            class="erkend-duurzaam"
            src="@/images/pages/erkend-duurzaam.svg"
          />
          <div class="bg-circle g-w"></div>
        </div>
      </section>

      <section class="row reverse">
        <div class="col text">
          <h2>Rijnja Ecoscore</h2>
          <p>
            Onze visie op duurzaamheidsprincipes reikt verder dan onze eigen
            organisatie. Wij willen ook bijdragen aan de
            ketenverantwoordelijkheid. Rijnja Ecoscore is een uniek en zelf
            ontwikkeld systeem waarmee we onze klanten helpen een verantwoorde
            en milieuvriendelijke(r) materiaalkeuze te maken. Op basis van
            onderzoek naar materiaaleigenschappen en herbruikbaarheid van
            verschillende rolmedia en plaatmateriaal is een classificatie
            gemaakt. Daarnaast zijn criteria opgesteld ten aanzien van
            grondstoffen, herbruikbaarheid, energie en CO2, herkomst en
            transport. Koninklijke Rijnja verzorgt de distributie met eigen
            elektrisch vervoer en ziet erop toe dat leveranciers en
            ingeschakelde transportbedrijven aan de strengste milieunormen
            voldoen.
          </p>
        </div>
        <div class="col image">
          <img class="kwaliteit" src="@/images/pages/ecoscore-logo.svg" />
        </div>
      </section>
      <section class="row" id="contact">
        <div class="col-single">
          <h1>Wilt u meer weten over onze diensten?</h1>
          <p class="form-text">
            Benieuwd naar wat Koninklijke Rijnja voor u kan betekenen? Neem dan
            contact met ons op via onderstaand formulier.
          </p>

          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag diensten"
            conversion-id="McMQCKuxhJwYEKDetesD"
          ></contact-form>
          <p>
            Wilt u een van onze vestigingen direct bereiken? Bekijk de
            contactgegevens dan op onze
            <router-link class="link-text" to="/contact"
              >contactpagina
            </router-link>
            .
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
import ContactForm from '../../components/ContactForm.vue'

export default {
  components: { SiteFooter, ContactForm }
}
</script>

<style lang="scss" scoped>
.erkend-duurzaam {
  max-width: 500px;
  padding-top: 60px;
}

.fsc {
  max-width: 155px;
}

.rijnja-duurzaam {
  max-width: 422px;
}

.kwaliteit {
  max-width: 370px;
}

.form {
  margin: 20px 0;
}

.form-text {
  padding-bottom: 0;
}
</style>
